import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
var fileDownload = require("js-file-download");
import { request } from "@/js/http/http_request";
import { listWineTypes, purchaseOrder, orderTypes } from "@/js/lists.ts";
import { toggleLegend } from "@/js/animation.js";
import { getErrorData } from "@/js/forms.js";
import SourcingItemData from "@/components/sourcing/SourcingItemData.vue";
import ImportSupplierPrices from "@/components/supplier-prices/ImportSupplierPrices.vue";
import SourcingSupplierTable from "@/components/sourcing/SourcingSupplierTable.vue";
import WineSupplierPriceModal from "@/components/supplier-prices/WineSupplierPriceModal.vue";
import { hasRole } from "@/js/http/auth";
export default {
  components: {
    SourcingItemData: SourcingItemData,
    ImportSupplierPrices: ImportSupplierPrices,
    SourcingSupplierTable: SourcingSupplierTable,
    WineSupplierPriceModal: WineSupplierPriceModal
  },
  props: {
    loggedUserData: Object
  },
  data: function data() {
    return {
      canManageSupplierPrices: false,
      canManagePos: false,
      filters: {
        label: ""
      },
      displayByWinery: false,
      displayBySupplier: false,
      datatableLoading: true,
      datatableItems: [],
      datatableHeaders: [{
        align: "center",
        text: "Order",
        value: "order",
        width: "20%"
      }, {
        align: "center",
        text: "Items",
        value: "itemsOrder",
        width: "50%"
      }],
      datatableWineryItems: {
        wineries: [],
        allItems: []
      },
      datatableHeadersByWinery: [{
        align: "center",
        text: "Producer",
        value: "winery",
        width: "20%"
      }, {
        align: "center",
        text: "Items",
        value: "items",
        width: "50%"
      }],
      currentWineId: null,
      isWineSupplierPriceModalShown: false,
      panelsOpened: null,
      isExporting: false,
      isImportSupplierPricesShown: false,
      orderTypes: orderTypes
    };
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.canManagePos = hasRole(process.env.VUE_APP_ROLES_MANAGE_PURCHASE_ORDERS);
            _this2.canManageSupplierPrices = hasRole(process.env.VUE_APP_ROLES_MANAGE_SUPPLIER_PRICES);
            _context.next = 4;
            return _this2.search();
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    search: function search() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var paramsQuery, _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.datatableItems = [];
              _this3.datatableWineryItems = [];
              _this3.datatableLoading = true;
              paramsQuery = Object.encodeToUri(_this3.filters);
              _this = _this3;
              _context2.next = 7;
              return request("/v1/sourcing?params=".concat(paramsQuery), "GET", {}, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions);
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                _this.datatableLoading = false;
                throw e;
              });
            case 7:
              response = _context2.sent;
              _this3.datatableItems = _toConsumableArray(response.data);
              _this3.keepOnlyDirectWineryItems();
              _this3.datatableItems.forEach(function (x) {
                x.orderSourcingGlobalStatus = _this3.getOrderGlobalStatus(x.items);
                switch (x.orderSourcingGlobalStatus) {
                  case 0:
                    x.orderCssClassStatus = "danger";
                    break;
                  case 1:
                    x.orderCssClassStatus = "warning";
                    break;
                  default:
                    x.orderCssClassStatus = "success";
                    break;
                }
              });
              _this3.datatableItems.sort(function (a, b) {
                return a.orderSourcingGlobalStatus - b.orderSourcingGlobalStatus;
              });
              _this3.datatableLoading = false;
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getPoItemStatus: function getPoItemStatus(poItem, globalItemQuantity) {
      if (poItem.receiptStatus === purchaseOrder.receiptStatus.RECEIVED && poItem.quantity >= globalItemQuantity) return "fas fa-check success";
      if (poItem.receiptStatus === purchaseOrder.receiptStatus.RECEIVED && poItem.quantity < globalItemQuantity) return "fas fa-check warning";
      if (poItem.status === purchaseOrder.status.DRAFT) return "fas fa-hourglass-half danger";
      return "fas fa-hourglass-half warning";
    },
    getWineryItemStatus: function getWineryItemStatus(item) {
      var itemQtyFilled = item.associatedPurchaseOrders.reduce(function (acc, x) {
        return acc + x.quantity;
      }, 0);
      var itemQtyReceived = item.associatedPurchaseOrders.filter(function (x) {
        return x.receiptStatus === purchaseOrder.receiptStatus.RECEIVED;
      }).reduce(function (acc, x) {
        return acc + x.quantity;
      }, 0);
      if (itemQtyFilled < item.quantity || item.associatedPurchaseOrders.some(function (x) {
        return x.status === purchaseOrder.status.DRAFT;
      })) return "danger";
      if (itemQtyReceived >= item.quantity) return "success";
      return "warning";
    },
    getOrderItemStatus: function getOrderItemStatus(item) {
      var itemQtyFilled = item.associatedPurchaseOrders.reduce(function (acc, x) {
        return acc + x.quantity;
      }, 0);
      var itemQtyReceived = item.associatedPurchaseOrders.filter(function (x) {
        return x.receiptStatus === purchaseOrder.receiptStatus.RECEIVED;
      }).reduce(function (acc, x) {
        return acc + x.quantity;
      }, 0);
      if (itemQtyFilled < item.quantity || item.associatedPurchaseOrders.some(function (x) {
        return x.status === purchaseOrder.status.DRAFT;
      })) return "danger";
      if (itemQtyReceived >= item.quantity) return "success";
      return "warning";
    },
    getOrderGlobalStatus: function getOrderGlobalStatus(items) {
      var _this4 = this;
      var statusArray = [];
      items.forEach(function (item) {
        statusArray.push(_this4.getOrderItemStatus(item));
      });
      if (statusArray.includes("danger")) return 0;
      if (statusArray.includes("warning")) return 1;
      return 2;
    },
    keepOnlyDirectWineryItems: function keepOnlyDirectWineryItems() {
      this.datatableItems.forEach(function (order) {
        order.items = order.items.filter(function (x) {
          return x.isDirectWinery;
        });
      });
    },
    generateByWineryData: function generateByWineryData() {
      var _this5 = this;
      var allItems = [];
      var wineries = [];
      this.datatableItems.forEach(function (order) {
        order.items.forEach(function (item) {
          if (!wineries.find(function (x) {
            return x.id == item.wine.producerId;
          })) {
            wineries.push(item.wine.producer);
          }
          allItems.push(item);
        });
      });
      if (this.filters.label) {
        var tempWineries = wineries.filter(function (x) {
          return x.name.toLowerCase().includes(_this5.filters.label.toLowerCase());
        });
        if (tempWineries.length > 0) wineries = tempWineries;
      }
      this.datatableWineryItems.wineries = wineries;
      this.datatableWineryItems.allItems = allItems;
    },
    getItemsByWinery: function getItemsByWinery(winery) {
      var items = this.datatableWineryItems.allItems.filter(function (x) {
        return x.wine.producerId === winery.id;
      });
      items = items.sort(function (a, b) {
        return a.wine.id_wine - b.wine.id_wine;
      });
      return items;
    },
    isPreviousSame: function isPreviousSame(previous, current) {
      if (!previous) return false;
      return previous.wine.id_wine === current.wine.id_wine;
    },
    copySkuToClipboard: function copySkuToClipboard(sku) {
      return navigator.clipboard.writeText(sku);
    },
    expandAllPanels: function expandAllPanels() {
      var _this6 = this;
      this.$nextTick(function () {
        _this6.panelsOpened = 0;
      });
    },
    collapseAllPanels: function collapseAllPanels() {
      var _this7 = this;
      this.$nextTick(function () {
        _this7.panelsOpened = null;
      });
    },
    exportSourcing: function exportSourcing() {
      var _this = this;
      _this.isExporting = true;
      var paramsQuery = Object.encodeToUri(_this.filters);
      request("/v1/sourcing/export?params=".concat(paramsQuery), "GET", null, true, "api", "blob").then(function (response) {
        _this.isExporting = false;
        fileDownload(response.data, "SOURCING_LIST.xlsx", "application/xlsx");
      }).catch(function (e) {
        var errorData = getErrorData(e, _this.managedExceptions);
        _this.$toasted.show(errorData.message, {
          type: errorData.type
        });
        _this.isExporting = false;
      });
    },
    itemRowQuotationStatusUpdated: function itemRowQuotationStatusUpdated(data) {
      var _this$datatableItems;
      var order = (_this$datatableItems = this.datatableItems) === null || _this$datatableItems === void 0 ? void 0 : _this$datatableItems.find(function (x) {
        return x.id_order == data.orderId;
      });
      var item = order === null || order === void 0 ? void 0 : order.items.find(function (x) {
        return x.id_item == data.itemId;
      });
      if (item != null) {
        if (item.sourcingData) {
          item.sourcingData.quotationStatus = data.newQuotationStatus;
        } else {
          item.sourcingData = {
            quotationStatus: data.newQuotationStatus
          };
        }
      }
    },
    itemRowCommentUpdated: function itemRowCommentUpdated(data) {
      var _this$datatableItems2;
      var order = (_this$datatableItems2 = this.datatableItems) === null || _this$datatableItems2 === void 0 ? void 0 : _this$datatableItems2.find(function (x) {
        return x.id_order == data.orderId;
      });
      var item = order === null || order === void 0 ? void 0 : order.items.find(function (x) {
        return x.id_item == data.itemId;
      });
      if (item != null) {
        if (item.sourcingData) {
          item.sourcingData.comment = data.newComment;
        } else {
          item.sourcingData = {
            comment: data.newComment
          };
        }
      }
    },
    importSupplierPrices: function importSupplierPrices() {
      this.isImportSupplierPricesShown = true;
    },
    goToOrder: function goToOrder(value) {
      return {
        name: "adminOrderSummary",
        params: {
          id: value
        }
      };
    },
    goToPurchaseOrder: function goToPurchaseOrder(value) {
      return {
        name: "adminEditPurchaseOrder",
        params: {
          id: value.id
        }
      };
    },
    goToProductDetails: function goToProductDetails(wine) {
      var detailsRoute = wine.type == listWineTypes.find(function (x) {
        return x.name === "Spirit";
      }).id ? "adminSpiritsDetails" : "adminWineDetails";
      return {
        name: detailsRoute,
        params: {
          id: wine.id_wine
        }
      };
    },
    openSupplierPrices: function openSupplierPrices(wineId) {
      var _this8 = this;
      this.currentWineId = wineId;
      this.isWineSupplierPriceModalShown = true;
      this.$nextTick(function () {
        _this8.$refs.wineSupplierPriceModalRef.open();
      });
    },
    closeSupplierPrices: function closeSupplierPrices() {
      this.isWineSupplierPriceModalShown = false;
    },
    toggleLegend: toggleLegend
  }
};